import { memo } from 'react';
import styled from 'styled-components';
// import { formatDate } from 'src/utils/functions';
import IconX from '../svg/IconX';

const MessageItem = memo(({ message, deleteMessage }) => {
  // const dateTime = formatDate(message.date);
  return (
    <StyledLi key={message.id}>
      <p>{message.message}</p>
      <strong>From. {message.name}</strong>
      {/* <time datetime={dateTime}>{dateTime}</time> */}
      <DeleteButton onClick={() => deleteMessage(message.id, message.password)}>
        <IconX />
        <span className="a11y-hidden">삭제</span>
      </DeleteButton>
    </StyledLi>
  );
});

const StyledLi = styled.li`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 15rem;
  height: 25rem;
  background: var(--background);
  padding: 2rem 1rem;
  border-radius: 1.5rem;
  box-sizing: border-box;
  text-align: center;
  font-size: 1.2rem;
  line-height: 1.6rem;

  & > p {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    overflow-y: auto;
  }

  & > strong {
    text-decoration: underline;
    text-underline-offset: 0.3rem;
    font-weight: 500;
  }

  & > time {
    color: var(--grayLv3);
  }
`;

const DeleteButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }

  path {
    fill: var(--grayLv3);
  }
`;

export default MessageItem;
